import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function OperatedFather() {
  return <section className="w-full bg-blue-50/60" data-id="element-83">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:px-6 lg:py-20" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="grid gap-8 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-85">
          <div className="overflow-hidden rounded-3xl border border-blue-100 bg-white shadow-sm" data-id="element-86">
            <img src="https://cdn.magicpatterns.com/uploads/1wRoiq3JbQJvK3ji4ua3Ck/-vu5q3FMYpIZURM8K4imj8ElKJduIzIBW9K5gqf9nMLBMB-y1j9xczDEQ-fLwLpSUbp4fpSrWE-QSxkPk2p8WF5L.jpg" alt="Портрет хирурга-ортопеда Павла Иванова" className="h-96 w-full object-cover object-top sm:h-[480px]" data-id="element-87" />
          </div>

          <div data-id="element-88">
            <h2 className="text-xl font-semibold leading-tight tracking-tight text-slate-900 sm:text-2xl lg:text-3xl" data-id="element-89">
              Я оперировал собственного отца
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-slate-600" data-id="element-90">
              Несколько лет назад моему отцу потребовалось эндопротезирование
              тазобедренного сустава.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-slate-600" data-id="element-91">
              Он мог выбрать любого хирурга в стране — но оперировал его я.
              Когда на столе твой отец, ты не имеешь права на ошибку — ни как
              хирург, ни как сын.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-slate-600" data-id="element-92">
              Операция прошла успешно: отец быстро восстановился и живёт
              активной жизнью без боли. Я работаю с каждым пациентом по такому
              же высокому стандарту. У каждого человека есть семья, которая ждёт
              его здоровым — и я отношусь к каждой операции так, как отнёсся бы,
              если бы оперировал близкого.
            </p>

            <blockquote className="mt-8 rounded-2xl border-l-4 border-blue-600 bg-white p-6" data-id="element-93">
              <Quote className="h-6 w-6 text-blue-300" aria-hidden="true" data-id="element-94" />
              <p className="mt-3 text-lg italic leading-relaxed text-slate-700" data-id="element-95">
                «Я работаю с пациентами так, как хотел бы, чтобы работали с
                моими родными».
              </p>
              <footer className="mt-3 text-base font-medium text-slate-500" data-id="element-96">
                — Иванов П.П.
              </footer>
            </blockquote>
          </div>
        </motion.div>
      </div>
    </section>;
}